import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useCallStore } from '@/stores/callStore'

/** Router state a phone action sets so its own navigation keeps the phone open. */
export const FROM_PHONE = { fromPhone: true } as const

/**
 * Going to another page (wheel, sidebar, a link) folds the phone away so the
 * new page is visible: the dialer closes, a live call drops to the top call
 * pill and keeps running. Never hangs up. Navigation the phone starts itself
 * (answer → caller's page, "Message" from history) passes `FROM_PHONE` in
 * router state and leaves it open. A ringing call has its own overlay.
 */
export function useMinimizePhoneOnNavigate(): void {
  const { pathname, state } = useLocation()
  const first = useRef(true)
  useEffect(() => {
    if (first.current) {
      first.current = false
      return
    }
    if ((state as { fromPhone?: boolean } | null)?.fromPhone) return
    const s = useCallStore.getState()
    if (s.softphoneExpanded && s.callStatus !== 'ringing') s.setSoftphoneExpanded(false)
    // Only a page change counts; filters that rewrite ?query keep the phone.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
}
